/* src/app/components/dialogs/select-folder/select-folder.component.scss */
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
/*# sourceMappingURL=select-folder.component.css.map */
